import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetFramesByOrderInput } from './GetFramesByOrderInput';
import { GetFramesByOrderOutput } from './GetFramesByOrderOutput';

export class GetFramesByOrderService extends HttpServiceBase {

  handle = (input: GetFramesByOrderInput): Promise<Result<GetFramesByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetFramesByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/frames`);
    return promise;
  }
}